import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/sign-up-login-screen/components/AuthClient.tsx");
